// 登录
export function login(_ref) {
  var loginUrl = _ref.loginUrl,
    env = _ref.env,
    _ref$testPassportUrl = _ref.testPassportUrl,
    testPassportUrl = _ref$testPassportUrl === void 0 ? 'https://passport.fanruan.com' : _ref$testPassportUrl,
    _ref$prodPassportUrl = _ref.prodPassportUrl,
    prodPassportUrl = _ref$prodPassportUrl === void 0 ? 'https://fanruanclub.com' : _ref$prodPassportUrl;
  if (loginUrl) {
    window.location.href = loginUrl;
  } else {
    var now_url = window.location.href;
    var passportUrl = env === 'test' ? testPassportUrl : prodPassportUrl;
    var fanruanSplitArray = now_url.split('fanruan.com');
    var onlyRouter = '/';
    if (Array.isArray(fanruanSplitArray) && fanruanSplitArray.length > 1) {
      var withoutHost = fanruanSplitArray[1];
      onlyRouter = withoutHost.split('?')[0];
    }
    window.location.href = "".concat(passportUrl, "/cas/login?service=").concat(window.location.origin, "/server/login/cas?redirect=").concat(onlyRouter);
  }
}

// 头像
export function userAvatar(uid) {
  var size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'small';
  return "https://bbs.fanruan.com/uc_server/avatar.php?uid=".concat(uid, "&size=").concat(size);
}

// 区分是pc还是mobile
export function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
export var generateRandomStr = function generateRandomStr() {
  return Math.random().toString(36).slice(-8);
};